import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagGL(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURfv6+tAZOvT09P7+/tccPd4eQOQlR+6oteZrgfPf4j+ETIIAAAHeSURBVDjLzZJBa9tAEIUHidKrBTrkKPYQRzdD/oAXdnv2Qau2V1Mp7q0YGsg1JIFeDW3af9v3Zlaqa0wg0EOfpNHse9+OsFm5flkr+RdAuaL4vl6typJrVIqJiGAJSamBvdXXBAW2FvYlb0r3TByWpLXaMwcyN0eavVJeoUaaAkVkqtll11CFBtqJK7gurJptC+cYsxetCElgg8bN89O4u2sc9yqqQ3ArjKk/R+qbMwRQwQ6kOIeXezua9vAdb24iDQATnbvNwI2z3E3iBGg5jH0/DOM47G0D5zqdZsCPwYi+/+z+VgYeB4rI7izQIkxEUt8fzgHLNODqEae0PwdcpUxA9xhI7zADh9Zdpix8aduSQHxoW7xtwgxA29NP0NwcHeM3KabUpRiN30jE4uMR8B1xRyjG2HXdRhKI90dn52vkFpuAZy0djA881naey8eOjj4BFZ8IXXh3NOETDARwI+taAo0vzaRlDLy0cAQAamvnA7rUNfdbk4GL+Xc/IJsVZyDc5/wqnGgCLuyvbx/+RHUGvA+1D/5GgVtvohVqaiHova/ranf36/kJjW6kY8haKp8JCK6vVDXsqkKwEDS8OFah/BFPC8ECE8ib8iCbwHVVAdB4Ck5UK/Ci/gvgN1Yb4VaJzp97AAAAAElFTkSuQmCC",
    alt: "GL"
  }, props));
}